import { render, staticRenderFns } from "./repairTypeDialog.vue?vue&type=template&id=0855ca74"
import script from "./repairTypeDialog.vue?vue&type=script&lang=js"
export * from "./repairTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports